import * as Sentry from '@sentry/react';
import { ROUTES } from 'app/utils/constants/paths';
import * as coreEntities from 'core/store/index';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { matchPath } from 'react-router-dom';

const AppContainer = ({ routerHistory }) => {
  const user = useSelector((state) => coreEntities.auth.selectors.getUser(state));

  useEffect(() => {
    if (typeof window.tangeriniaWidget !== 'undefined' && typeof window.tangeriniaWidget.user !== 'undefined' && user?.guid) {
      console.log('window.tangeriniaWidget in user useEffect: ', window.tangeriniaWidget);
      window.tangeriniaWidget.setUser(user?.role_name.toUpperCase(), user?.name, user?.avatar);
    }
  }, [user]);

  useEffect(() => {
    const routes = Object.values(ROUTES)
      .map((route) => ({
        path: route,
      }))
      .sort((a, b) => b.path.length - a.path.length);

    Sentry.init({
      dsn: 'https://c583e7250991f783148988b55836f209@o4505759437029376.ingest.us.sentry.io/4506257572626432',
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.reactRouterV5BrowserTracingIntegration({ history: routerHistory, routes, matchPath }),
        Sentry.thirdPartyErrorFilterIntegration({
          // Specify the application keys that you specified in the Sentry bundler plugin
          filterKeys: ['tangerine-frontoffice'],

          // Defines how to handle errors that contain third party stack frames.
          // Possible values are:
          // - 'drop-error-if-contains-third-party-frames'
          // - 'drop-error-if-exclusively-contains-third-party-frames'
          // - 'apply-tag-if-contains-third-party-frames'
          // - 'apply-tag-if-exclusively-contains-third-party-frames'
          behaviour: 'drop-error-if-contains-third-party-frames',
        }),
      ],
      // Performance Monitoring
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      // tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
  }, []);

  return <></>;
};

export default AppContainer;
